/* __next_internal_client_entry_do_not_use__ ProductLinkForBrandPage auto */ import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { useProductUrlBrandPage } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductLink/Brand/useProductUrlBrandPage";
import { useOnProductClickForBrandPage } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/productTileActions/useOnProductClickForBrandPage";
/**
 * On brand page, the entire product tile is clickable including white space, therefore this component needs a children attribute.
 */ export var ProductLinkForBrandPage = function(param) {
    var children = param.children, productClickForBrandPageParameters = param.productClickForBrandPageParameters, productToken = param.productToken, selectedProductOptionToken = param.selectedProductOptionToken, brandToken = param.brandToken;
    var productUrl = useProductUrlBrandPage({
        productToken: productToken,
        selectedProductOptionToken: selectedProductOptionToken,
        brandToken: brandToken
    }).productUrl;
    var onProductClick = useOnProductClickForBrandPage(productClickForBrandPageParameters);
    return /*#__PURE__*/ _jsx(ProductLink, {
        onClick: onProductClick,
        "data-test-id": "product-tile-link-".concat(productToken),
        to: productUrl,
        children: children
    }, "".concat(productToken, "-product-tile"));
};
var ProductLink = styled(Link).withConfig({
    componentId: "sc-104c3273-0"
})([
    "flex:1;display:flex;flex-direction:column;position:relative;"
]);
